/** Hiển thị độ khó quiz (giá trị API: easy | medium | hard). */
export function quizDifficultyLabel(t, raw) {
  const d = String(raw || 'medium').toLowerCase();
  if (d === 'easy') return t('quiz.difficulty.easy');
  if (d === 'hard') return t('quiz.difficulty.hard');
  return t('quiz.difficulty.medium');
}
